<template>
  <el-pagination style="margin-top:15px;" @current-change="list();" @size-change="(val)=>{ this.page.size = val;this.list();}" :current-page.sync="page" :page-sizes="sizes" :page-size="size" :total="total" background layout="sizes,prev,pager,next"></el-pagination>
</template>
<script>
export default {
  data() {
    return {
      page: 1, size: 10, total: 20, sizes: [10, 20, 30, 50],
    };
  },
  methods: {
    list() {
      this.$parent.$parent.list();
    }
  },
  watch: {
    //监听内容变化
  }
}
</script>